import View from '../Support/View/View';

export default class Btn extends View {

    static get viewName() {
        return 'btn';
    }
    static get viewType() {
        return 'component';
    }

    get isLoading() {
        return !!this.$el.getAttribute('aria-busy');
    }
    get isDisabled() {
        return !!this.$el.disabled;
    }

    /**
     * @param {Boolean} shouldBeDisabled 
     */
    setDisabledStateTo(shouldBeDisabled) {
        this.$el.disabled = shouldBeDisabled;
    }

    /**
     * @param {Boolean} shouldBeLoading 
     */
    setLoadingStateTo(shouldBeLoading) {
        if (!this.$el.classList.contains('has-loader')) {
            return;
        }

        this.setDisabledStateTo(!!shouldBeLoading);

        if (!this.initialAriaLabel) {
            this.initialAriaLabel = this.$el.getAttribute('aria-label');
        }

        if (shouldBeLoading) {
            this.$el.setAttribute('aria-busy', true);
            this.$el.setAttribute('aria-label', 'Chargement en cours; veuillez patienter...');

            return;
        }

        this.$el.removeAttribute('aria-busy');

        if (this.initialAriaLabel && (this.initialAriaLabel !== 'Chargement en cours; veuillez patienter...')) {
            this.$el.setAttribute('aria-label', this.initialAriaLabel);
        } else {
            this.$el.removeAttribute('aria-label');
        }
    }
}